import { Custom404 } from "@/components/errors/Custom404/Custom404";

export default Custom404;
